import { render } from "./EditCompanyModal.vue?vue&type=template&id=cf9778f4&ts=true"
import script from "./EditCompanyModal.vue?vue&type=script&lang=ts"
export * from "./EditCompanyModal.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__